import { SHORTCUT_LIST } from './useKeyboardShortcuts'

interface ShortcutsHelpProps {
  onClose: () => void
}

export function ShortcutsHelp({ onClose }: ShortcutsHelpProps) {
  const categories = [...new Set(SHORTCUT_LIST.map(s => s.category))]

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60"
      onClick={onClose}
    >
      <div
        className="bg-zinc-900 border border-zinc-700 rounded-lg shadow-xl w-80 max-h-[80vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-3 border-b border-zinc-700">
          <h3 className="text-sm font-medium text-zinc-200">Raccourcis clavier</h3>
          <button
            onClick={onClose}
            className="text-zinc-400 hover:text-zinc-200 text-xs px-2 py-0.5 rounded hover:bg-zinc-700"
          >
            Fermer
          </button>
        </div>
        <div className="p-3 space-y-3">
          {categories.map(cat => (
            <div key={cat}>
              <div className="text-[10px] text-zinc-500 uppercase tracking-wide mb-1.5">{cat}</div>
              <div className="space-y-1">
                {SHORTCUT_LIST.filter(s => s.category === cat).map(s => (
                  <div key={s.keys} className="flex items-center justify-between text-xs">
                    <span className="text-zinc-300">{s.label}</span>
                    <Kbd keys={s.keys} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function Kbd({ keys }: { keys: string }) {
  const parts = keys.replace(' (maintenu)', '').split('+')
  const suffix = keys.includes('(maintenu)') ? ' (maintenu)' : ''
  return (
    <span className="flex items-center gap-0.5 shrink-0">
      {parts.map((p, i) => (
        <span key={i}>
          {i > 0 && <span className="text-zinc-600 mx-0.5">+</span>}
          <span className="inline-block px-1.5 py-0.5 bg-zinc-800 border border-zinc-600 rounded text-[10px] text-zinc-300 font-mono leading-none">
            {p}
          </span>
        </span>
      ))}
      {suffix && <span className="text-[9px] text-zinc-500 ml-0.5">{suffix}</span>}
    </span>
  )
}
